<div class="d-flex justify-content-center align-items-center" style="min-height: 250px;min-width: 300px;">
  <mat-spinner [diameter]="70" strokeWidth="5" style="opacity:.35"></mat-spinner>
</div> 